<template>
  <b-standard-card
    :title="translations.title[lang]"
    :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
    height="auto"
    :loading="loading"
    :error-message="errorMessage"
    @submit="uploadLoyaltyLogo({ type: 'loyalty_logo', imageFile })"
  >
    <div
      v-if="storeMode"
      style="height: 100px"
      v-text="translations[`info_${storeMode}`][lang]"
    ></div>

    <v-row no-gutters align="center" style="height: 120px">
      <v-col cols="12" sm="5" class="pr-2">
        <v-skeleton-loader
          v-if="companyLoading"
          type="image"
          width="64"
          height="64"
          class="mx-auto rounded-circle"
        ></v-skeleton-loader>
        <v-img
          v-else
          :src="loyalty_logo"
          width="64"
          height="64"
          class="mx-auto rounded-circle"
        ></v-img>
      </v-col>
      <v-col cols="12" sm="7" class="pl-0 pl-sm-2">
        {{ translations.uploadText[lang] }}
        <v-file-input
          v-model="fileInput"
          color="secondary"
          class="mt-1"
          outlined
          dense
          hide-details="auto"
          :rules="rules"
          :success="success"
        ></v-file-input>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="6">
            <clipper-basic :src="imageUrl" ref="clipper"></clipper-basic>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                class="text-capitalize px-5"
                style="font-size: 0.9rem"
                @click="getClippedResult"
                >clip image</v-btn
              >
            </v-card-actions>
          </v-col>
          <v-col cols="6">
            <v-card-title class="justify-center">Result</v-card-title>
            <v-card-subtitle class="text-center"
              >This is the final result that will be displayed as your store logo</v-card-subtitle
            >
            <v-divider></v-divider>

            <v-card-text class="text-center">
              <v-sheet height="258">
                <img
                  :src="resultURL"
                  width="250"
                  height="250"
                  class="rounded-circle"
                  :class="{ 'b-image-border': resultURL }"
                />
              </v-sheet>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="text-capitalize"
                style="font-size: 0.9rem"
                text
                @click="
                  () => {
                    fileInput = null;
                    dialog = false;
                  }
                "
                >cancel</v-btn
              >
              <v-btn
                color="secondary"
                class="text-capitalize px-5"
                style="font-size: 0.9rem"
                :disabled="!resultURL"
                @click="changeImage"
                >save</v-btn
              >
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <!-- {{ loyaltyPanel }} -->
  </b-standard-card>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';

import translations from '@/utils/translations/loyaltyLogo';

export default {
  name: 'LoyaltyLogo',

  mixins: [translations],

  data() {
    return {
      dialog: false,
      fileInput: null,
      imageUrl: null,
      resultURL: null,
      loyalty_logo: '',
      imageFile: '',
      success: false,
      rules: [
        (v) => {
          if (v) {
            this.success = true;
            return true;
          } else {
            return 'To continue you must upload a new image';
          }
        },
      ],
    };
  },

  computed: {
    ...mapState(['loyaltyPanel']),
    lang() {
      return this.$route.params.lang;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    companyLoading() {
      return this.$store.state.loyaltyPanel.loading;
    },

    loading() {
      return this.$store.state.loyaltyPanel.businessProfile.loading.loyalty_logo;
    },

    errorMessage() {
      return this.$store.state.loyaltyPanel.businessProfile.errorMessage.loyalty_logo;
    },

    resetSuccess() {
      return this.$store.state.loyaltyPanel.businessProfile.resetSuccess.loyalty_logo;
    },
  },

  methods: {
    ...mapMutations('loyaltyPanel/businessProfile', ['setResetSuccess']),
    ...mapActions('loyaltyPanel/businessProfile', ['uploadLoyaltyLogo']),

    onFileSelected(event) {
      this.resultURL = null;
      this.dialog = true;
      if (event) {
        if (this.imageUrl) URL.revokeObjectURL(this.imageUrl);
        this.imageUrl = URL.createObjectURL(event);
      }
    },

    getClippedResult() {
      const canvas = this.$refs.clipper.clip();
      this.resultURL = canvas.toDataURL('image/jpeg', 1);
    },

    changeImage() {
      this.loyalty_logo = this.resultURL;
      let blobBin = atob(this.resultURL.split(',')[1]);
      let arr = [];

      for (let i = 0; i < blobBin.length; i++) {
        arr.push(blobBin.charCodeAt(i));
      }

      this.imageFile = new Blob([new Uint8Array(arr)], {
        type: 'image/png',
      });

      this.dialog = false;
    },
  },

  watch: {
    ['$store.state.loyaltyPanel.company']: {
      immediate: true,
      handler(val) {
        this.loyalty_logo = val.loyalty_logo;
      },
    },

    fileInput(val) {
      if (val) this.onFileSelected(val);
    },

    success(val) {
      if (val) this.setResetSuccess({ type: 'loyalty_logo', value: false });
    },

    resetSuccess(val) {
      if (val) this.success = false;
    },
  },
};
</script>

<style scoped>
.b-image-border {
  border: 1px solid rgba(0, 0, 0, 0.26);
}
</style>
